export const LEGACY_CLIENT_CONSENT_REQUIRED_MESSAGE =
  'Client consent is required before accessing this client.';

export const CLIENT_CONSENT_REQUIRED_MESSAGE =
  'Client consent is required before accessing this client. please check the client email for consent email';

export const CLIENT_CONSENT_REVOKED_MESSAGE =
  'Client consent has been revoked. Access is blocked until consent is granted again.';

const normalizeMessage = (message: string): string => message.trim().toLowerCase();

export const normalizeClientConsentAccessMessage = (message: string): string => {
  const normalized = normalizeMessage(message);
  if (normalized === normalizeMessage(LEGACY_CLIENT_CONSENT_REQUIRED_MESSAGE)) {
    return CLIENT_CONSENT_REQUIRED_MESSAGE;
  }
  return message;
};

export const isClientConsentAccessBlockedMessage = (message: string | null | undefined): boolean => {
  if (!message) {
    return false;
  }

  const normalized = normalizeMessage(message);
  return (
    normalized === normalizeMessage(LEGACY_CLIENT_CONSENT_REQUIRED_MESSAGE) ||
    normalized === normalizeMessage(CLIENT_CONSENT_REQUIRED_MESSAGE) ||
    normalized === normalizeMessage(CLIENT_CONSENT_REVOKED_MESSAGE)
  );
};
